export default {
  budgetWatchLists: [],
};
